/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import $ from 'jquery';
window.$ = window.jQuery = $;

import _ from 'lodash';
window._ = _;

import select2 from 'select2';
select2();

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import * as Sentry from '@sentry/browser';

Sentry.init({
    dsn: 'https://205d9f8cc9777bfacc0f49ba609ed799@sentry.brainbox.cc/4',
    tunnel: '/error-tracing',
    integrations: [
        new Sentry.BrowserTracing(),
        new Sentry.Replay({
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableTracing: true,
    tracesSampleRate: 0.2,
    release: "beholder-site-js@1.0.0",
    tracePropagationTargets: [],
    environment: "production",
});

const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
        container: 'body'
    });
});

const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {
        animation: true,
        show: 500,
        hide: 100,
    });
});


const event = new Event('go');
window.dispatchEvent(event);
